import React, {useContext} from 'react';
import {
   Card,
   makeStyles, TablePagination, Typography,
} from '@material-ui/core';

import {SearchContext} from "../../lib/contexts";
import AIResultItem from "../AIResultItem";
import SearchResultItem from "../SearchResultItem";

const useStyles = makeStyles({
   searchResult: {
      marginTop:0,
      width: '100%',
      maxHeight: 750,
      overflowY: 'auto',
      textAlign:'left'
   },
   noResults:{
      textAlign:'center',
      display:'block',
      margin:'50px auto 50px',
      '& p':{
         marginTop:-2,
         fontSize:15
      }
   },
   resultsTitle:{marginLeft:15, marginTop:20, textAlign:'center'}
});
const SearchResults = () => {
   const classes = useStyles();
   const {
      state: {searchResults, resultsLoading, debounceQuery, page, rowsPerPage, totalSearchResults },
      actions: {setPage, setRowsPerPage },
   } = useContext(SearchContext);
   
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   
   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
   };
   
   return(<>
      {
         debounceQuery !== "" && searchResults && !resultsLoading ?
            <>
      <Typography variant="h5" component="h2" className={classes.resultsTitle} style={{display:'none'}}>
         "{debounceQuery}"
      </Typography>
<Card className={classes.searchResult}>
   <SearchResultItem item={searchResults}/>
</Card>
               <TablePagination
                  style={{margin:'auto',display:'none'}}
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalSearchResults}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            </>
         :
         searchResults && searchResults.length === 0 ? <Typography variant={'h6'} className={classes.noResults}>No Results found.<p>Try another phone number.</p></Typography> : ''
      }
</>
)
};

export default SearchResults;
